<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
			<h2 class="ml-0 mb-0 mt-0">
				<div class="d-flex flex-wrap justify-content-between align-items-center">
					<div class="breadcrumbactive">
						<div>
							<span class="pointer" @click="redirectSales">Sales Forecast</span>
							<div>View Sales Forecast</div>
						</div>
					</div>
					<button class="btn btn-new-green btn-wide px-6 bg-color" v-if="loggedInUser.user_role == 'sales_manager' && userPermissions.sales_forecast.permitted_actions.create" @click="createSalesForecast()"> + Create Sales Forecast</button>
				</div>
			</h2>
			<div class="pt-10" style="background-color:#fff;border-radius:8px">
				<div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress && sales_forecast_details == null">
					<half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
				</div>
				<div v-else-if="!ajaxCallInProgress && sales_forecast_details">
					<!-- <div class="row title-btn justify-content-end">
						<div>
							<span class="fs-14  pl-3 ml-3 title-sales">{{sales_forecast_details.product_name}}</span>
						</div>
					</div> -->
					<div class="main-div">
						<div class="create-company-header d-flex align-items-center justify-content-between">
							<span class="fs-14  pl-10 text-white ml-3 header-text">{{sales_forecast_details.name}}</span>
							<span class="description-text-header-right" style="padding-right: 30px;">
								<span class="fs-14  pl-3 text-white ml-3 header-value">
									<!-- {{sales_forecast_details.territory+' , '+sales_forecast_details.country}} -->
									<!-- {{sales_forecast_details.territory + ' , ' || ' '}}  -->
									{{sales_forecast_details.territory == null ? '' : sales_forecast_details.territory + ' , '}}
									{{sales_forecast_details.country}}
								</span>
								<img class="header-spacing" src="/static/icons/crm/pin.svg" alt />
								<span class="pointer ml-1" @click="assignTarget()" v-if="userPermissions.sales_forecast.permitted_actions.edit && (loggedInUser.user_role != 'sales_person' && sales_forecast_details.status == 'un_assigned') || userPermissions.sales_forecast.permitted_actions.edit && (loggedInUser.user_role != 'sales_person' && sales_forecast_details.status == 'need_to_assign')">
									<i class="icon-pencil text-white edit-icon header-spacing"></i>
								</span>
							</span>
						</div>
					</div>
					<div class="container-fluid table-contents">
						<span class="fs-14 title-header" v-if="loggedInUser.user_role == 'sales_manager'">1. Sales Manager</span>
						<span class="fs-14 title-header" v-if="loggedInUser.user_role == 'team_lead'">1. Team lead</span>
						<div class="table-datas my-6">
							<table class="team-smallview-table w-100 table-responsive text-center">
								<thead>
									<tr>
										<th class="th-sm">Target Amount ({{currency}})</th>
										<th class="th-sm">Achieved Deals ({{sales_forecast_details.achieved_count}})</th>
										<th class="th-sm">Achieved (%)</th>
										<th class="th-sm">Deals in Pipeline ({{sales_forecast_details.pipeline_amount}})</th>
										<th class="th-sm">Remaining (%)</th>
										<th class="th-sm">Predicted Probability</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{sales_forecast_details.target}}</td>
										<td style="color:#0475f3;" class="pointer" @click="listDeals('won')">{{sales_forecast_details.percentage_achieved}}</td>
										<td>{{sales_forecast_details.total_achieved}}</td>
										<td style="color:#0475f3;" class="pointer" @click="listDeals('active')">{{sales_forecast_details.pipeline_amount}}</td>
										<td>{{sales_forecast_details.remaining}}</td>
										<td>{{sales_forecast_details.predicted_probability}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="loggedInUser.user_role != 'sales_person'">
							<span class="fs-14 title-header">2. Assigned to</span>
							<div class="table-datas my-6">
								<table class="team-view-table  w-100 table-responsive text-center">
									<thead>
										<tr>
											<th class="th-sm">Team Lead</th>
											<th class="th-sm">Target Amount ({{currency}})</th>
											<th class="th-sm">Achieved</th>
											<th class="th-sm">Achieved (%)</th>
											<th class="th-sm">Amount in Pipeline</th>
											<th class="th-sm">Remaining (%)</th>
											<th class="th-sm">Predicted Probability</th>
										</tr>
									</thead>
									<tbody>
										<tr v-if="sales_forecast_details.assignation.length == 0">
											<td colspan="7" class="fw-600 text-center">No Data</td>
										</tr>
										<tr v-else v-for="(list,index) in sales_forecast_details.assignation" :key="index">
											<td>{{list.assigned_to_person}}</td>
											<td>{{list.assigned_amount}}</td>
											<td>{{list.total_achieved}}</td>
											<td>{{list.percentage_achieved}}</td>
											<td>{{list.pipeline_amount}}</td>
											<td>{{list.remaining}}</td>
											<td>{{list.predicted_probability}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
        </div>
		<CreateSalesforecast @hideCreateSalesForecast="hideCreateSalesForecast" v-if="create_sales_forecast" modal_name="Create-Sales"/>
		<list-deals :selected_deal="selected_deal" v-if="show_deals" @hideDeals="hideDeals" :sales_forecast_details="sales_forecast_details" modal_name="List-Deals"></list-deals>
    </div>
</template>
<script>
import CreateSalesforecast from './CreateSalesforecast';
import { HalfCircleSpinner } from "epic-spinners";
import salesforecast from "../mixins/salesforecast";
import ListDeals from './ListDeals';
import DisplayDeals from './DisplayDeals';
import { EventBus } from '../eventBus/nav-bar-event';
export default {
	components:{
		HalfCircleSpinner,
		ListDeals,
		DisplayDeals,
		CreateSalesforecast,
	},
	mixins:[salesforecast],
	data() {
		return {
			erp_unit: [],
            department: [],
			product: [],
			sales_forecast_details: null,
			ajaxCallInProgress: false,
			show_deals: false,
			selected_deal: "",
			view_sale: true,
			display_deals:false,
			currency:'',
			create_sales_forecast: false,
		}
	},
	methods: {
		hideCreateSalesForecast(){
			this.create_sales_forecast= false
		},
		createSalesForecast() {
			this.create_sales_forecast= true
			setTimeout(() => {
				if(this.set_target){
					this.set_target= false;
					this.show_lists = true;
				}
				this.$modal.show("Create-Sales");
			}, 500);
		},
		assignTarget(){
			this.$router.push({
				name: "SalesCast",
				params:{
					id: this.$route.params.id
				}
			})
		},
		redirectSales(){
			this.$router.push("/salesForeCast/salesCast/list")
		},
		hideDeals(){
			this.show_deals = false
		},
		listDeals(obj) {
			this.selected_deal = obj
			this.show_deals = true
			setTimeout(() => {
				this.$modal.show("List-Deals");
			}, 500);
		},
		async loadSalesForecastDetails(){
			this.ajaxCallInProgress = true
			let response = await this.getSalesForecastDetails(this.$route.params.id)
			this.sales_forecast_details = response.response
			this.ajaxCallInProgress = false
		},
		displayDeals(){
			this.display_deals = true;
		},
	},
	computed:{
		loggedInUser() {
            return this.$store.state.loggedInUser;
		},
		userPermissions(){
			return this.$store.getters.userPermissions;
		}
	},
	mounted(){
		this.currency = this.loggedInUser.currency.symbol;
		this.loadSalesForecastDetails()
		EventBus.$on("back_button", (value) =>{
			this.display_deals = value;
		});
	}
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .create-company-container {
        background-color: #fff;
        padding: 30px 0 0px 0;
        border-radius: 6px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
	.title-btn{
		justify-content: space-between;
    	margin: 0px 50px 10px 45px;
	}
	.title-sales{
		color:#0475f3;
		font-weight: 600;
	}
	.table-contents{
		padding: 10px 40px 50px 80px;
	}
	.table-datas{
		border: 1px solid #707070;
    	border-radius: 5px;
	}
	.team-smallview-table thead tr th {
		background: #00448b;
		color: #fff;
		padding: 10px 66px;
		font-size: 13px;
		font-weight: 400;
		white-space: nowrap;
		width:50%;
	}
	.team-smallview-table tbody tr td {
		background: #fff;
		padding: 10px 66px;
		font-size: 13px;
		font-weight: 400;
		border-bottom: 1px solid #f2f3f5;
		white-space: nowrap;
		width:50%;
	}
	.team-smallview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-smallview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-smallview-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
	.team-view-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-view-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-view-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
	.team-view-table thead tr th {
		background: #00448b;
		color: #fff;
		padding: 10px 56px;
		font-size: 13px;
		font-weight: 400;
		white-space: nowrap;
		width:50%;
	}
	.team-view-table tbody tr td {
		background: #fff;
		padding: 10px 56px;
		font-size: 13px;
		font-weight: 400;
		border-bottom: 1px solid #f2f3f5;
		white-space: nowrap;
		width:50%;
	}
	.title-header{
		color: #0475f3;
		font-weight: 500;
	}
	.description-text-header-right {
		font-size: 24px;
		margin-left: auto;
		padding-left: 12px;
		color: #005dae;
		font-weight: 500;
	}
	.header-value {
		padding-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/ViewSalesForecast.vue